import { z } from 'zod';
import { createServiceHttpClient } from '@wit-support/core-ports';
// Contract: app-service portraits endpoints (service-to-service).
// Auth: `Authorization: Bearer <APP_API_KEY>` (static shared secret, NOT a user JWT).
// `GET /internal/user/{userId}/portraits`
//   Success: 200 `{ "success": "success", "data": { "portraits": [{ key, name, url }] } }`
//            (empty array when the user has no portraits).
// `GET /internal/user/{userId}/portrait-soulmate-main`
//   Success: 200 `{ "success": "success", "data": { key, name, url } }`
//            (404 when there is no ready soulmate portrait).
// Errors:  400/404/422 `{ success: "error", error }`, 401/403 `{ status, message }`.
// Parsing is tolerant of extra fields and only requires the fields we surface; any non-2xx
// (including 404), network/abort/parse error → fail soft (null).
const ItemSchema = z.object({
    key: z.string(),
    name: z.string(),
    url: z.string().url(),
});
const PortraitsResponseSchema = z.object({
    data: z.object({ portraits: z.array(ItemSchema) }),
});
const SoulmateResponseSchema = z.object({
    data: ItemSchema,
});
export const createHttpPortraitsPort = (opts) => {
    const client = createServiceHttpClient({
        baseUrl: opts.baseUrl,
        ...(opts.apiKey !== undefined && { apiKey: opts.apiKey }),
        ...(opts.fetchFn !== undefined && { fetchFn: opts.fetchFn }),
        ...(opts.timeoutMs !== undefined && { timeoutMs: opts.timeoutMs }),
    });
    return {
        async listPortraits(userId) {
            try {
                const res = await client.get(`/internal/user/${encodeURIComponent(userId)}/portraits`);
                if (!res.ok)
                    return null;
                const parsed = PortraitsResponseSchema.safeParse(await res.json());
                return parsed.success ? parsed.data.data.portraits : null;
            }
            catch {
                // Network error / AbortError (timeout) → fail soft, mirroring the !res.ok path.
                return null;
            }
        },
        async getSoulmatePortrait(userId) {
            try {
                const res = await client.get(`/internal/user/${encodeURIComponent(userId)}/portrait-soulmate-main`);
                if (!res.ok)
                    return null;
                const parsed = SoulmateResponseSchema.safeParse(await res.json());
                return parsed.success ? parsed.data.data : null;
            }
            catch {
                // Network error / AbortError (timeout) → fail soft, mirroring the !res.ok path.
                return null;
            }
        },
    };
};
//# sourceMappingURL=portraits.js.map